export var FORM_INPUTS = [
    {
        name: 'name',
        label: 'shop.shopName',
        placeholder: 'shop.shopName',
    },
    {
        name: 'domain',
        label: 'shop.domain',
        placeholder: 'shop.domain',
    },
];
